export default () => ({ getState }) => next => action => {
  if (action.error && action.error.crossDomain) {
    // It's a connectivity issue with the API, the client is likely to be offline. Redirect to the Offline page
    const { intl: { locale } } = getState();
    window.location.replace(`${locale}/offline`);
  }
  next(action);
};
